<template>
    <el-dialog v-dialogDrag  class="dialog" width="800px"
               :visible.sync="dialogVisible" v-loading="dialoading"
               append-to-body
               :close-on-click-modal="false" @close="close" center>
        <div slot="title">
            <div class="dialog_title">
                编辑续费信息
            </div>
        </div>
        <div class="dialog_body">
            <el-form :inline="true" :model="form" ref="formData" v-loading="loading"  label-width="120px"
                     style="padding: 15px;padding-top: 10px">
                <el-form-item label="所属部门">
                    <el-input style="width:200px" v-model="form.departmentNameBill" readonly></el-input>
                </el-form-item>
                <el-form-item label="项目名称">
                    <el-input style="width:200px" v-model="form.projectName" readonly></el-input>
                </el-form-item>
                <el-form-item label="订单编号">
                    <el-input style="width:200px" v-model="form.billNo" readonly></el-input>
                </el-form-item>

                <el-form-item label="客户名称(乙方)">
                    <el-input style="width:200px" v-model="form.customerName" ></el-input>
                </el-form-item>
                <el-form-item label="签订日期">
                    <el-input style="width:200px" v-model="form.billDate" readonly></el-input>
                </el-form-item>
                <el-form-item label="交付日期">
                    <el-input style="width:200px" v-model="form.deliveryDate" readonly></el-input>
                </el-form-item>

                <el-form-item label="续费人">
                    <el-input style="width:200px" v-model="form.renewBy" placeholder="请输入续费人"></el-input>
                </el-form-item>
                <el-form-item label="续费日期">
                    <el-date-picker type="date" placeholder="续费日期"
                                    style="width: 200px"
                                    value-format="yyyy-MM-dd"
                                    v-model="form.renewDate"></el-date-picker>
                </el-form-item>
                <el-form-item label="续费金额">
                    <el-input style="width:200px" v-model="form.renewTotal" type="number" ></el-input>
                </el-form-item>

                <el-form-item label="维保到期日期">
                    <el-date-picker type="date" placeholder="维保到期日期"
                                    style="width: 200px"
                                    value-format="yyyy-MM-dd"
                                    v-model="form.expirationDate"></el-date-picker>
                </el-form-item>

                <el-form-item label="备注" class="bzClass">
                    <el-input
                            resize="none"
                            type="textarea"
                            placeholder="请输入备注"
                            v-model="form.remark"
                            rows="2"
                            show-word-limit>
                    </el-input>
                </el-form-item>
            </el-form>

            <div style="text-align: center;padding: 10px 0px 20px 0px">
                <el-button type="danger" @click="close">取 消</el-button>
                <el-button type="primary" @click="submitForm">保 存</el-button>
            </div>
        </div>
    </el-dialog>
</template>

<script>

    export default {
        name: "editDialog",
        props: ['formData', 'loading'],
        components: {},
        data() {
            return {
                dialoading: this.loading,
                form: JSON.parse(JSON.stringify(this.formData)),
                dialogVisible: true,
                formLabelWidth: '80px',
            };
        },
        methods: {
            close() {
                this.$emit('closeDialog', this.dialogVisible)
            },
            async submitForm() {

                if(this.$pub.isEmpty(this.form.expirationDate)){
                    this.$message({message: '请输入下次维保到期日期', type: 'error'});
                    return false;
                }

                let param = {
                    ...this.form,
                }
                const data = await this.$sqlOpt.save.save(param, "/saleorderrenew/save");
                if (data.infoCode === '0') {
                    this.$message.success("保存成功");
                    this.close();
                }
            },
        }
    }
</script>
